import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Col } from 'reactstrap'
import { ApexCharts } from '../../../Components'

export default function PorLaboratorio({ dataGrid }) {
  const [interacoesPorLaboratorio, setInteracoesPorLaboratorio] = useState([])

  useEffect(() => {
    if (dataGrid) {
      const interacoesPorLaboratorio = contarInteracoesPorLaboratorio(dataGrid)
      setInteracoesPorLaboratorio(interacoesPorLaboratorio)
    }
  }, [dataGrid])

  const contarInteracoesPorLaboratorio = (dataGrid) => {
    const interacoesPorLaboratorio = {}

    dataGrid.forEach((item) => {
      const laboratorio = item.laboratorioNm
      if (laboratorio != null) {
        if (laboratorio in interacoesPorLaboratorio) {
          interacoesPorLaboratorio[laboratorio]++
        } else {
          interacoesPorLaboratorio[laboratorio] = 1
        }
      }
    })

    return Object.entries(interacoesPorLaboratorio).map(([laboratorio, interacoes]) => ({ laboratorio, interacoes }))
  }

  const config = {
    series: [
      {
        data: interacoesPorLaboratorio.map((item) => item.interacoes),
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 300,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: 'end',
          horizontal: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: interacoesPorLaboratorio.map((item) => item.laboratorio),
      },
    },
  }

  return (
    <Card className="main-card mb-2">
      <CardHeader>Interações por laboratório</CardHeader>
      <CardBody style={{ textAlign: 'center' }}>
        <ApexCharts options={config.options} series={config.series} type="bar" height={335} />
      </CardBody>
    </Card>
  )
}
